import { ValueFormatterParams } from 'ag-grid-community';

export function defaultColWithErrorsFormatter(
  params: ValueFormatterParams<string | number | undefined | null>
): string {
  if (params.value) {
    return params.value || '';
  }
  return '';
}
